
import { useLanguage } from "@/hooks/useLanguage";
import { useDashboardData } from "@/hooks/useDashboardData";
import { DashboardError } from "./DashboardError";
import { DashboardCards } from "./DashboardCards";
import { DashboardSettings, CardSizes, CardSize } from "@/hooks/useDashboardSettings";

interface DashboardGridProps {
  days: number;
  settings: DashboardSettings;
  onLayoutChange?: (newOrder: string[]) => void;
  onCardSizeChange?: (cardId: keyof CardSizes, size: Partial<CardSize>) => void;
}

export default function DashboardGrid({ days, settings, onLayoutChange, onCardSizeChange }: DashboardGridProps) {
  const { t } = useLanguage();
  const {
    data,
    isLoading,
    error,
    isError,
    refetch,
    isRefetching,
  } = useDashboardData(days);

  if (isError && error) {
    return (
      <DashboardError
        error={error}
        refetch={refetch}
        isRefetching={isRefetching}
      />
    );
  }

  return (
    <DashboardCards
      data={data}
      isLoading={isLoading}
      days={days}
      settings={settings}
      onLayoutChange={onLayoutChange}
      onCardSizeChange={onCardSizeChange}
    />
  );
}
